import React from 'react';

const CONTACTS = [
  {
    icon: '📧',
    label: 'Email',
    value: 'jyo.bh15@gmail.com',
    href: 'mailto:jyo.bh15@gmail.com',
    external: false,
  },
];

export default function ContactPage() {
  return (
    <div className="max-w-2xl mx-auto space-y-6">

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-8">
        <h3 className="text-xl font-bold text-gray-900 mb-0.5">Contact Us</h3>
        <p className="text-gray-500 text-sm mb-8">
          We&apos;re here to help. Reach out through any channel below or use the{' '}
          <strong>Ask Us</strong> portal for platform-specific questions.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {CONTACTS.map(({ icon, label, value, href, external }) => (
            <a
              key={label}
              href={href}
              target={external ? '_blank' : undefined}
              rel={external ? 'noopener noreferrer' : undefined}
              className="flex items-center gap-4 p-4 rounded-xl border border-gray-100 hover:border-indigo-200 hover:bg-indigo-50 transition-all duration-150 group"
            >
              <span className="text-3xl leading-none">{icon}</span>
              <div className="min-w-0">
                <p className="text-xs text-gray-400 font-medium">{label}</p>
                <p className="text-gray-800 font-semibold text-sm truncate group-hover:text-indigo-700 transition-colors">
                  {value}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Response time callout */}
      <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-5 flex gap-4">
        <span className="text-2xl leading-none">⏱️</span>
        <div>
          <p className="text-indigo-800 font-semibold text-sm">Typical Response Time</p>
          <p className="text-indigo-700 text-sm mt-0.5">
            We reply within <strong>24 – 48 hours</strong> on business days. For urgent issues,
            email us directly.
          </p>
        </div>
      </div>

    </div>
  );
}
